import React, { useReducer, useState } from 'react';
import { CreatedCalculation, Props } from './Listing.types';
import ListingHeader from './Header/Header';
import { List } from './partials';
import { State as LocalItemsState } from 'utils/store/localItemsStore/types';
import { createInitialState, reducer } from 'utils/store/localItemsStore';
import { CreateCalculationResponse } from 'modules/af_tool/api/types';
import { allCalculations } from 'modules/af_tool/api';
import { afTool } from 'routes/routePaths';
import useBodyClass from 'helpers/hooks/useBodyClass';

import styles from './ListingPage.module.scss';
import { mapCreateResponse } from './utils/mapper';
import useApiWrapper from 'helpers/hooks/useApiWrapper';
import { Modal } from 'modules/af_cm_ui_kit/components';

const ListingPage: React.FC<Props> = ({ history }) => {
  const [state, stateDispatch] = useReducer<React.Reducer<LocalItemsState<CreatedCalculation>, any>>(
    reducer,
    createInitialState(false),
  );
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  useBodyClass(...styles['af_tool'].split(' '));

  const calculationsState = useApiWrapper({ runRequest: allCalculations });

  const handleCreateNewAffordability = (newAffordabilityData: CreateCalculationResponse) => {
    const { calculationId } = mapCreateResponse(newAffordabilityData);
    history.push(`${afTool.index}/${calculationId}`);
  };

  return (
    <>
      <ListingHeader onCreateNewAffordability={handleCreateNewAffordability} localStore={[state, stateDispatch]} />
      <div className={styles.listWrapper}>
        {calculationsState.pending && <div>Loading..</div>}
        {calculationsState.loaded && calculationsState.data && (
          <List
            calculations={calculationsState.data.calculations}
            onDeleteButtonClick={setIsDeleteModalVisible.bind(null, true)}
          />
        )}
        <Modal
          isOpen={isDeleteModalVisible}
          title="Not implemented yet."
          onClose={setIsDeleteModalVisible.bind(null, false)}></Modal>
      </div>
    </>
  );
};

export default ListingPage;
